export default __webpack_public_path__ + "static/media/beacon_restrict_inbound_calls_icon.f5d6a89f.png";